/**
 * Convinience method for checking availability of refs
 */

export default {
  name: 'check-ref',
  methods: {
    /**
     * Check if ref is present
     *
     * @returns {Vue.Element} element if found
     */
    checkRef(ref) {
      if (!this.$refs) {
        throw new Error('No $refs');
      }

      if (!this.$refs[ref]) {
        throw new Error(`no ${ref}`);
      }

      return this.$refs[ref];
    },
  }
};
